<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { changeThemeColor, curColor, curBlackColor } from '@/utils/themeColorClient.js'

export default {
  data() {
    return {}
  },
  created() {
    // const site = this.$ls.get('site')
    // if (site) {
    //   this.$store.commit('updateSite', site)
    //   this.changeSite(site)
    // }

    this.getSiteData()

    // 默认语言设置，zh ja en
    let lang

    lang = this.$ls.get('language')

    if (!lang) {
      if (navigator.language) {
        lang = navigator.language
      } else {
        lang = navigator.userLanguage
      }
    }

    if (lang.indexOf('zh') == 0) {
      this.currentLg = 'zh'
    } else if (lang.indexOf('en') == 0) {
      this.currentLg = 'en'
    } else if (lang.indexOf('ja') == 0) {
      this.currentLg = 'ja'
    } else {
      this.currentLg = 'en'
    }

    // this.currentLg = 'en'

    this.$ls.set('language', this.currentLg)
    this.$store.commit('updateLanguage', this.currentLg)
    console.log('currentLg', this.currentLg)
  },
  methods: {
    // 获取网站信息
    getSiteData() {
      getAction(`/pc/home/queryByUserId`, {
        // userId: this.fromId,
      }).then((res) => {
        this.$store.commit('updateSite', res.result)
        this.$ls.set('site', res.result)
        this.changeSite(res.result)
      })
    },
    changeSite(site) {
      const { secondaryColor, mainColor, websiteName, pcWebsiteLogo } = site
      // 网站标题
      document.title = websiteName

      // 网站icon
      var link = document.querySelector("link[rel~='icon']")
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.href = pcWebsiteLogo

      // 主题颜色
      if (secondaryColor != curColor || mainColor != curBlackColor) {
        this.changeColor(secondaryColor, mainColor)
      }
    },
    changeColor(secondaryColor, mainColor) {
      changeThemeColor(secondaryColor, mainColor).then(() => {
        console.log('主题色切换成功啦~')
      })
    },
  },
}
</script>
